// Format phone number as 303-333-3333.
// #153 (Group G): coerce to string before .replace so a numeric value
// (e.g. a legacy contact whose phone was stored as a JS Number, or a
// migration that wrote 3033333333 as an integer) doesn't crash
// Settings/Customer pages with "value.replace is not a function".
export function formatPhoneNumber(value) {
  if (value === null || value === undefined) return "";
  const digits = String(value).replace(/\D/g, "").slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
  return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6)}`;
}
